module.exports = __webpack_public_path__ + "static/media/gen-key-figure.7273da46.png";